module.exports = __webpack_public_path__ + "img/avatar2.d6815a5e.png";